import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/table";
import type { IExamSet } from "@/apis/exam_sets/types";

interface ExamSetListTableProps {
  data: IExamSet[];
  loading: boolean;
  total: number;
  page: number;
  pageSize: number;
  onPageChange: (page: number, pageSize: number) => void;
}

const statusLabel: Record<string, string> = {
  active: "Active",
  inactive: "Inactive",
  archived: "Archived",
};

const ExamSetListTable: React.FC<ExamSetListTableProps> = ({
  data,
  loading,
  total,
  page,
  pageSize,
  onPageChange,
}) => {
  const navigate = useNavigate();

  const handleViewExamSet = (id: string) => {
    navigate(`/exam_sets/${id}`);
  };

  if (loading) {
    return <div className="text-center py-8">Loading exam sets...</div>;
  }

  if (!data || data.length === 0) {
    return (
      <div className="text-center py-8 text-zinc-500">No exam sets found.</div>
    );
  }

  return (
    <Table className="mt-4">
      <TableHead>
        <TableRow>
          <TableHeader>Title</TableHeader>
          <TableHeader>Type</TableHeader>
          <TableHeader>Questions</TableHeader>
          <TableHeader>Duration (min)</TableHeader>
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map((set) => {
          let totalQuestions = 0;
          let totalDuration = 0;
          set.items?.forEach((item) => {
            const paper = item.exam_paper;
            if (paper?.sections) {
              totalQuestions += paper.sections.reduce(
                (sum, section) => sum + (section.question_ids?.length || 0),
                0
              );
              totalDuration += paper.sections.reduce(
                (sum, section) => sum + (section.duration || 0),
                0
              );
            }
          });
          return (
            <TableRow
              key={set.id}
              className="cursor-pointer hover:bg-gray-50"
              onClick={() => handleViewExamSet(set.id)}
            >
              <TableCell>
                <div className="font-medium">{set.title}</div>
              </TableCell>
              <TableCell>{set.exam_type}</TableCell>
              <TableCell>{totalQuestions}</TableCell>
              <TableCell>{totalDuration}</TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default ExamSetListTable;
